// src/config/authReturnPath.ts — restores the pre-login deep link after the
// Auth0 redirect round-trip. AuthContext stores the visited path before it
// hands off to Auth0 (the SDK's appState is the primary carrier; sessionStorage
// is the fallback for transactions that lose it), and the Auth0Provider's
// onRedirectCallback calls restoreAuthReturnPath once the code/state exchange
// completes on the callback URL (the app origin, path "/").
export const AUTH_RETURN_PATH_STORAGE_KEY = "authReturnTo";

export interface AuthRedirectState {
  returnTo?: string;
}

export const restoreAuthReturnPath = (appState?: AuthRedirectState): void => {
  const storedReturnTo = sessionStorage.getItem(AUTH_RETURN_PATH_STORAGE_KEY);
  const nextPath =
    appState?.returnTo ||
    storedReturnTo ||
    `${window.location.pathname}${window.location.search}${window.location.hash}`;

  sessionStorage.removeItem(AUTH_RETURN_PATH_STORAGE_KEY);

  // Keep the current entry's history state: React Router stores its history
  // index (idx) there, and replacing it with a fresh object breaks the
  // router's back/forward delta bookkeeping.
  window.history.replaceState(window.history.state, document.title, nextPath);

  // React Router only re-reads window.location on a popstate event, so a bare
  // replaceState leaves the router's own location on the Auth0 callback URL
  // ("/"). That route immediately <Navigate>s to /portal/dashboard, clobbering
  // the just-restored deep link — every full-page load of /console/* (or any
  // other deep link) appeared to "redirect to the portal". The synthetic
  // popstate makes the router adopt the restored path before the routes render.
  window.dispatchEvent(
    new PopStateEvent("popstate", { state: window.history.state })
  );
};
